export const NUMBER = 437;
export const NAME = `Detected a Horror enemy, but this quest does not require The Horror.`;
export const DESCRIPTION = `You can set your quest to require The Horror in the Publish dialog.`;

// TODO; requires some sort of awareness of quest settings
export const INVALID = [] as any[];

export const VALID = [] as any[];
